import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import en from './locales/en.json';

// Configuration i18n pour le Projet Albion
i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en }
    },
    lng: localStorage.getItem('ALBION_LANGUAGE') || 'fr', // Français par défaut
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false // React échappe déjà les valeurs
    }
  });

export default i18n;
